<template>
    <navBar title="Ares - Users" :home="true" type="gebr"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }
</script>
